import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import axios from 'axios';

import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { PersitedDatePicker } from '../../../components/common';

import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { IData } from './helpers/interface';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../services/auth/AuthProvider';
import SupervisorTable from './components/tablelist/SupervisorTable';
import AdminTable from './components/tablelist/AdminTable';
import { Loader } from '../../../components/common/Loader';

const statusObj = {
  pending: 1,
  accepted: 2,
  rejected: 3,
};

const List = () => {
  const { state } = useAuth();
  const date = useQuery('date');
  const [tableData, setTableData] = useState<IData[]>([]);
  const [render, setRender] = useState(false);
  const { user, IS } = state;
  const [images, setImages] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE ',
    'Are you sure you want to delete this document?',
  );
  useEffect(() => {
    let userType = '';
    user?.userType === IS.Admin
      ? (userType = 'admin')
      : (userType = 'supervisor');

    if(!date) {return}

    axios
      .get(`/api/luxMonitoringReport/yearly/${userType}/${date}`)
      .then((res) => {
        if (res.data) setTableData(res.data);
      })
      .catch((err) => console.log(err));
  }, [render, date]);

  const deleteDocument = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    axios
      .delete(`/api/luxMonitoringReport/${id}`)
      .then(() => {
        alert('document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
    return;
  };

  const updateStatus = async (id: string, documentIndex: number) => {
    let isConfirm = window.confirm('Are you sure you want to update status');
    if (isConfirm && tableData.length > 0) {

      const filteredTableData = tableData.filter(item => item._id === id)
      const status = filteredTableData.length > 0 ? filteredTableData[0].status : '';

      axios
        .patch(`/api/luxMonitoringReport/updateStatus/${id}`, {
          status,
        })
        .then((res) => {
          if (res.data.status === 'success') {
            alert('Status Change successfully');
          }
          setRender((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleChangeStatus = (
    e: React.ChangeEvent<HTMLSelectElement>,
    documentIndex: number,
  ) => {
    
  };

  const uploadImage = async (id: string, files: any) => {
    if (!window.confirm('Are you sure want to upload files?')) {
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    setIsLoading(true);
    axios
      .patch(`/api/luxMonitoringReport/uploadImage/${id}`, formData)
      .then((res) => {
        alert('file upload successfully');
        setIsLoading(false);
        setRender((prev) => !prev);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <Loader loader={isLoading} />
      <ChildHeader text="lux MONITORING REPORT CHECK-SHEET">
        <AddButton
          onClick={() =>
            navigate(`/common/qualityChecksheets/createLuxMonitoringReport`)
          }
          label="NEW REPORT"
        />
      </ChildHeader>
      <Box sx={{ margin: 2 }}>
        <PersitedDatePicker label="Search By Year" views={['year']} />
      </Box>
      {user?.userType === IS.Admin && (
        <AdminTable
          {...{
            deleteDocument,
            uploadImage,
            updateStatus,
            statusObj,
            tableData,
          }}
        />
      )}
      {user?.userType === IS.Supervisor && (
        <SupervisorTable {...{ uploadImage, deleteDocument, tableData }} />
      )}
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
